import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { UserOperation } from '../../../../core/enums/user-operation';
import { ClientModel } from '../../../../core/models/client/client.model';
import { ShiveDialogService } from '../../../../core/services/controls/shive-dialog.service';
import { ProjectModel } from '../../../../core/models/project/project.model';

@Component({
  selector: 'app-client-dialog',
  templateUrl: './client-dialog.component.html',
  standalone: false,
})
export class ClientDialogComponent {
  @ViewChild('dialogFooter') dialogFooter: TemplateRef<unknown>;
  @Input() userOperation: UserOperation;
  @Input() clientModel: ClientModel;
  public UserOperation = UserOperation;

  constructor(private readonly shiveDialogService: ShiveDialogService) {}

  public delete(): void {
    const updatedClientModel = new ProjectModel();
    Object.assign(updatedClientModel, this.clientModel);
    updatedClientModel.userOperation = this.userOperation;

    this.shiveDialogService.close(updatedClientModel);
  }

  public close(): void {
    this.shiveDialogService.close();
  }
}
